import { ITransportTerm } from '../../../components/TransportAccessibilityRate';
import { MAX_TRANSPORT_ACCESSIBILITY_RATE } from '../../../constants/transportAccessibility';
import { ITransportAccessibilityTerm } from '../../../types/newbuilding/transportAccessibility';
import { prepareRate } from './prepareRate';

export const prepareTransportAccessibility = (terms: ITransportAccessibilityTerm[]): ITransportTerm[] => {
  return terms.map(({ rate, title }) => {
    const rateText = prepareRate(rate);
    const rateLabel = `${title} ${rateText}`;
    const rateIndex = rate / MAX_TRANSPORT_ACCESSIBILITY_RATE;

    return {
      title,
      rateIndex,
      rateLabel,
      rateText,
    };
  });
};
